export default "__VITE_ASSET__5gQ17ozv__"